"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMER_KEYS = void 0;
exports.customerValues = customerValues;
/**
 * The customer provider's key space.
 *
 * Adding a key here and not producing it in `customerValues` is a COMPILE
 * ERROR (that function `satisfies Record<CustomerKey, string | undefined>`).
 * That is the whole point: you cannot declare a field the platform has no
 * code path to fill.
 */
exports.CUSTOMER_KEYS = [
    'legal_name', 'dba', 'ein', 'address', 'city', 'state', 'postal_code',
    'phone', 'email', 'business_type', 'location_name',
];
const nonBlank = (v) => typeof v === 'string' && v.trim().length > 0 ? v.trim() : undefined;
/**
 * THE FALL-THROUGH IS THE POINT. `legalEntityName` and `ein` live on the
 * LOCATION, not the tenant. Resolving against the location a deal names means
 * a multi-location tenant needs nothing extra asked of it.
 */
function customerValues(tenant, location) {
    const a = location?.address;
    const street = [a?.line1, a?.line2].filter(p => nonBlank(p)).join(', ');
    const full = a && nonBlank(a.city)
        ? `${street}, ${a.city}, ${a.state ?? ''} ${a.postalCode ?? ''}`.replace(/\s+/g, ' ').trim()
        : undefined;
    return {
        legal_name: nonBlank(location?.legalEntityName) ?? nonBlank(tenant.businessName),
        dba: nonBlank(tenant.businessName),
        ein: nonBlank(location?.ein),
        address: nonBlank(full),
        city: nonBlank(a?.city),
        state: nonBlank(a?.state),
        postal_code: nonBlank(a?.postalCode),
        phone: nonBlank(tenant.phone),
        email: nonBlank(tenant.ownerEmail),
        business_type: nonBlank(tenant.businessType),
        location_name: nonBlank(location?.name),
    };
}
//# sourceMappingURL=customer.js.map